import BackupModal from "../components/modals/BackupModal";
import LearnCodeModal from "../components/modals/LearnCodeModal";
import EquipmentsListModal from "../components/modals/EquipmentsListModal";
import EquipmentsNameModal from "../components/modals/EquipmentNameModal";
import ScenarioNameModal from "../components/modals/ScenarioNameModal";
import ScenarioCommandInfoModal from "../components/modals/ScenarioCommandInfoModal";
import EquipmentButtonIconModal from "../components/modals/EquipmentButtonIconModal";
import ChangeNameModal from "../components/modals/ChangeNameModal";
import ChartModal from "../components/modals/ChartModal";
import Footer from "./Footer";
import Menu from "./Menu";
import MenuDetail from "./MenuDetail";
import MobileTopMenu from "./MobileTopMenu";
import "./Layout.css";
import LazyLoad from "../components/LazyLoad";
import { useContext, useEffect, useRef } from "react";
import { Context } from "../context/Context";
import { useNavigate, useParams } from "react-router-dom";
import RoomNameModal from "../components/modals/RoomNameModal";

const Layout = ({ children }) => {
  const {
    rooms,
    setCurrentRoom,
    authUser,
    equipments,
    setRoomEquipments,
    currentRoom,
  } = useContext(Context);

  const navigate = useNavigate();
  const { room_id: roomId } = useParams();
  const hasInitializedRef = useRef(false);

  // فقط یکبار اجرا می‌شه
  useEffect(() => {
    if (!hasInitializedRef.current && authUser?.id && rooms.length > 0) {
      hasInitializedRef.current = true;

      if (!roomId) {
        const firstRoom = rooms[0];
        if (firstRoom && !currentRoom) {
          setCurrentRoom(firstRoom.id);
          const roomEquipmentsFiltered = equipments.filter(
            (eq) => eq.room_id == firstRoom.id,
          );
          setRoomEquipments(roomEquipmentsFiltered);
        }
      } else {
        const room = rooms.find((r) => r.id == roomId);
        if (room && !currentRoom) {
          setCurrentRoom(room.id);
          const roomEquipmentsFiltered = equipments.filter(
            (eq) => eq.room_id == room.id,
          );
          setRoomEquipments(roomEquipmentsFiltered);
        }
      }
    }
  }, [authUser?.id, rooms.length]);

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          {/* منوها - فقط یکبار رندر می‌شن */}
          <Menu />
          <MenuDetail />
          <LazyLoad />

          <div className="layout-page">
            <div className="content-wrapper">
              <MobileTopMenu />
              {children} {/* محتوای صفحات اینجا رندر می‌شه */}
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      {/* مدال‌ها */}
      <BackupModal />
      <LearnCodeModal />
      <EquipmentsListModal />
      <EquipmentsNameModal />
      <ScenarioNameModal />
      <ScenarioCommandInfoModal />
      <EquipmentButtonIconModal />
      <ChangeNameModal />
      <ChartModal />
      <RoomNameModal />
    </>
  );
};

export default Layout;
